<template>
  <div id="app">
    <AppHeader v-if="showHeaderFooter" />
    <component :is="currentPage" />
    <AppFooter v-if="showHeaderFooter" />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import AppHeader from './components/Header.vue'
import HomePage from './components/HomePage.vue'
import AppFooter from './components/Footer.vue'
import LoginPage from './components/Login.vue'
import MemberManagementPage from './components/MemberManagement.vue'

const MissionPage = defineAsyncComponent(() => import('./components/Mission.vue'))
const ExecutiveCouncilPage = defineAsyncComponent(() => import('./components/Council.vue'))
const MilestonesPage = defineAsyncComponent(() => import('./components/Milestones.vue'))
const FAQPage = defineAsyncComponent(() => import('./components/FAQ.vue'))
const PoiChingSchoolPage = defineAsyncComponent(() => import('./components/PoiChingSchool.vue'))
const HistoricalMaterialsPage = defineAsyncComponent(() => import('./components/HistoricalMaterials.vue'))
const Election86Page = defineAsyncComponent(() => import('./components/Election86Page.vue'))
const Zaobao86CouncilPage = defineAsyncComponent(() => import('./components/Zaobao86CouncilPage.vue'))
const SpringReception2026Page = defineAsyncComponent(() => import('./components/SpringReception2026Page.vue'))
const MothersDayRegPage = defineAsyncComponent(() => import('./components/MothersDayRegPage.vue'))
const Karaoke2026Page = defineAsyncComponent(() => import('./components/Karaoke2026Page.vue'))
const JoinUsPage = defineAsyncComponent(() => import('./components/JoinUs.vue'))
const VenueRentalPage = defineAsyncComponent(() => import('./components/VenueRental.vue'))
const QrGeneratorPage = defineAsyncComponent(() => import('./components/QrGenerator.vue'))
const BookingsPage = defineAsyncComponent(() => import('./components/BookingsPage.vue'))

const PAGE_META = {
  '#home': { title: '新加坡福清会馆 | 联络乡情 促进乡谊 - 新加坡乡团官方网站', description: '新加坡福清会馆官方网站。联络乡情，促进乡谊。了解会馆宗旨、理事会、培青学校、历史长廊、场地租用及加入我们。新加坡福清同乡会。' },
  '#mission': { title: '宗旨 | 新加坡福清会馆', description: '了解新加坡福清会馆的创会宗旨与使命，联络乡情，促进乡谊。' },
  '#council': { title: '理事会 | 新加坡福清会馆', description: '新加坡福清会馆理事会成员与组织架构。' },
  '#milestones': { title: '里程碑 | 新加坡福清会馆', description: '新加坡福清会馆自1910年创立以来的重要历史里程碑。' },
  '#faq': { title: '常见问题 | 新加坡福清会馆', description: '新加坡福清会馆与培青学校常见问题解答。' },
  '#poiching': { title: '培青学校 | 新加坡福清会馆', description: '新加坡福清会馆附属培青学校介绍与报名信息。' },
  '#historical-materials': { title: '历史长廊 | 新加坡福清会馆', description: '新加坡福清会馆历史纪录片与珍贵影像。' },
  '#materials': { title: '历史长廊 | 新加坡福清会馆', description: '新加坡福清会馆历史纪录片与珍贵影像。' },
  '#86election': { title: '福清会馆86届理事选举 | 新加坡福清会馆', description: '福清会馆第八十六届理事选举信息。' },
  '#zaobao-86council': { title: '福清会馆换届 年轻专业理事占比近六成 | 联合早报报道 | 新加坡福清会馆', description: '新加坡福清会馆第86届理事会换届报道：年轻专业理事占比近六成，徐华、刘礼垚、林惠敏等新理事分享加入缘起与发展计划。' },
  '#cny-2026': { title: '2026新春团拜 | 新加坡福清会馆新春团拜 近500人欢聚庆丙午马年', description: '新加坡福清会馆2026年新春团拜：近500名会员乡亲与嘉宾齐聚福清大厦礼堂，舞狮、武术、抽奖与奖助金颁发，共庆丙午马年。' },
  '#karaoke-2026': { title: '第16届会馆杯卡啦OK歌唱比赛 | 新加坡福清会馆', description: '新加坡福清会馆第16届会馆杯卡啦OK歌唱比赛报名详情，包含会馆会员及乡亲、宗乡总会兄弟会馆、少儿组报名信息及表格下载。' },
  '#join': { title: '加入我们 | 新加坡福清会馆', description: '加入新加坡福清会馆，成为会员，参与乡团活动。' },
  '#join-us': { title: '加入我们 | 新加坡福清会馆', description: '加入新加坡福清会馆，成为会员，参与乡团活动。' },
  '#venue': { title: '场地租用 | 新加坡福清会馆', description: '福清大厦场地租用信息，位于新加坡爱伦比路。' },
  '#venue-rental': { title: '场地租用 | 新加坡福清会馆', description: '福清大厦场地租用信息，位于新加坡爱伦比路。' },
  '#login': { title: '登录 | 新加坡福清会馆', description: '新加坡福清会馆会员登录。' },
  '#qr': { title: 'QR Code Generator | 新加坡福清会馆', description: 'QR code generator utility.' },
  '#bookings': { title: '场地预订日历 | 新加坡福清会馆', description: '实时场地预订日历，查看每日上午与下午时段状态，提交预订申请。' }
}

const DEFAULT_META = PAGE_META['#home']

export default {
  name: 'App',
  components: {
    AppHeader,
    HomePage,
    MissionPage,
    ExecutiveCouncilPage,
    MilestonesPage,
    FAQPage,
    PoiChingSchoolPage,
    HistoricalMaterialsPage,
    Election86Page,
    Zaobao86CouncilPage,
    SpringReception2026Page,
    MothersDayRegPage,
    Karaoke2026Page,
    JoinUsPage,
    VenueRentalPage,
    MemberManagementPage,
    LoginPage,
    QrGeneratorPage,
    BookingsPage,
    AppFooter
  },
  data() {
    return {
      currentHash: window.location.hash
    }
  },
  computed: {
    currentPage() {
      if (this.currentHash === '#login') {
        return 'LoginPage'
      }
      if (this.currentHash === '#members' ||
          this.currentHash === '#member-management' ||
          this.currentHash === '#user-management') {
        return 'MemberManagementPage'
      }
      if (this.currentHash === '#mission') {
        return 'MissionPage'
      }
      if (this.currentHash === '#council') {
        return 'ExecutiveCouncilPage'
      }
      if (this.currentHash === '#milestones') {
        return 'MilestonesPage'
      }
      if (this.currentHash.startsWith('#faq')) {
        return 'FAQPage'
      }
      if (this.currentHash === '#poiching') {
        return 'PoiChingSchoolPage'
      }
      if (this.currentHash === '#historical-materials' || this.currentHash === '#materials') {
        return 'HistoricalMaterialsPage'
      }
      if (this.currentHash === '#86election') {
        return 'Election86Page'
      }
      if (this.currentHash === '#zaobao-86council') {
        return 'Zaobao86CouncilPage'
      }
      if (this.currentHash === '#cny-2026') {
        return 'SpringReception2026Page'
      }
      if (this.currentHash === '#mothers-day-reg') {
        return 'MothersDayRegPage'
      }
      if (this.currentHash === '#karaoke-2026') {
        return 'Karaoke2026Page'
      }
      if (this.currentHash === '#join' || this.currentHash === '#join-us') {
        return 'JoinUsPage'
      }
      if (this.currentHash === '#venue' || this.currentHash === '#venue-rental') {
        return 'VenueRentalPage'
      }
      if (this.currentHash === '#qr') {
        return 'QrGeneratorPage'
      }
      if (this.currentHash === '#bookings') {
        return 'BookingsPage'
      }
      return 'HomePage'
    },
    showHeaderFooter() {
      const isLoginPage = this.currentHash === '#login'
      const isMemberPage = this.currentHash === '#members' ||
                          this.currentHash === '#member-management' ||
                          this.currentHash === '#user-management'
      return !isLoginPage && !isMemberPage
    }
  },
  mounted() {
    window.addEventListener('hashchange', this.handleHashChange)
    this.handleHashChange()
  },
  beforeUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange)
  },
  methods: {
    handleHashChange() {
      const hash = window.location.hash || '#home'
      this.currentHash = hash
      this.applyPageMeta(hash)
    },
    applyPageMeta(hash) {
      const meta = PAGE_META[hash] || DEFAULT_META
      document.title = meta.title
      const descEl = document.querySelector('meta[name="description"]')
      if (descEl) {
        descEl.setAttribute('content', meta.description)
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-color: #c8102e;
  --primary-dark: #a00d25;
  --secondary-color: #f4a261;
  --background: #ffffff;
  --surface: #f8f9fa;
  --text-primary: #2c3e50;
  --text-secondary: #6c757d;
  --border-color: #dee2e6;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 
    'Microsoft YaHei', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 
    'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--background);
  color: var(--text-primary);
  line-height: 1.6;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}
</style>
